
angular.module('qkr.merchant.reports').controller('ByorController', ByorController);

function ByorController(byorService, reportService, $log, messageService, $location,
                        $timeout, $window, appConfig, $scope, utils, $uibModal, gettextCatalog, departments, columns,
                        reportSpec, generating, reportsErrorService, $routeParams) {
    const vm = this;

    class SelectableDept {
        constructor(id, name, selected) {
            this.id = id;
            this.name = name;
            this.selected = selected;
        }
    }

    class ByorColumn {
        constructor(name, label) {
            this.name = name;
            this.label = label;
        }
    }


    vm.departments = departments;
    vm.columns = columns;
    vm.reportSpec = reportSpec;

    vm.byorReport = {
        id: null,
        name: '',
        scheduleInterval: 'daily',
        scheduleHour: 17,
        scheduleDay: utils.getDaysOfWeek()[0].name,
        scheduleDayOfMonth: 1,
        scheduleMinute: 0,
        email: '',
        emailList: [],
        date: {
            startDate: new Date(),
            startTime: reportService.getDateTime(0, 0, 0),
            endDate: new Date(),
            endTime: reportService.getDateTime(23, 59, 59)
        },
        selectableDepts: [],
        selectableDeptsRows: [],
        selectedColumns: []
    };

    vm.allAvailableByorColumns = [];

    vm.form = {};

    vm.busy = true;
    vm.generating = generating;

    vm.CUSTOM_REPORT = vm.generating ? gettextCatalog.getString('Custom Report' ) :
        gettextCatalog.getString('Edit Custom Report');


    vm.scheduleIntervals = reportService.getScheduleIntervals();
    vm.days = utils.getDaysOfWeekWithSelected();
    vm.daysOfMonth = reportService.getDaysOfMonth();
    vm.daysOfWeek = utils.getDaysOfWeek();
    vm.hours = reportService.getHours();
    vm.minutes = reportService.getMinutes();

    function createSelectableDepts(departments) {
        vm.byorReport.selectableDepts = departments.map(d => (new SelectableDept(d.id, d.name, true)));
        vm.byorReport.selectableDeptsRows = splitIntoRows(vm.byorReport.selectableDepts);
    }

    function splitIntoRows(l) {
        const ret = [[], [], []];
        const numRows = Math.ceil(l.length / 3);
        l.forEach((d, idx) => {
            const r = Math.floor(idx / (numRows + 1));

            ret[r].push(d);
        });
        return ret;
    }

    function createColumns(columnInfo) {
        vm.allAvailableByorColumns = columnInfo.cols.map(c => (new ByorColumn(c.name, c.label)));
        vm.byorReport.selectedColumns = columnInfo.cols
            .filter(c => isDefault(c.name))
            .map(c => new ByorColumn(c.name, c.label));
    }

    function isDefault(name) {
        return ['transaction.ref', 'purchase.date', 'purchase.time', 'Student First Name',
            'Student Last Name', 'product', 'quantity', 'Class', 'Year'].indexOf(name) >= 0;
    }

    function init() {
        if (vm.reportSpec) {
            vm.byorReport.id = vm.reportSpec;
        }

        createColumns(vm.columns);
        createSelectableDepts(vm.departments);

        if (vm.reportSpec) {
            updateFromReportSpec(vm.reportSpec);
        }

        vm.busy = false;
    }

    function updateFromReportSpec(reportSpec) {
        vm.byorReport.id = reportSpec.id;
        vm.byorReport.name = reportSpec.name;
        vm.byorReport.scheduleInterval = reportSpec.scheduleInterval;
        vm.byorReport.scheduleHour = reportSpec.scheduleHour;

        utils.setSelectedDays(reportSpec.scheduleDay, vm.days);
        if (reportSpec.scheduleDayOfMonth) {
            vm.byorReport.scheduleDayOfMonth = parseInt(reportSpec.scheduleDayOfMonth, 10);
        }
        vm.byorReport.scheduleMinute = reportSpec.scheduleMinute;
        vm.byorReport.emailList = reportSpec.emailList;

        updateSelectableDepartments(reportSpec);

        vm.byorReport.selectedColumns = [];
        reportSpec.byor.cols.forEach(colName => {
            const customField = vm.allAvailableByorColumns.find(cf => colName === cf.name);
            vm.byorReport.selectedColumns.push(new ByorColumn(customField.name, customField.label));
        });
        vm.busy = false;
    }

    function updateSelectableDepartments(reportSpec) {
        const oldSelectableDepts = vm.byorReport.selectableDepts;
        vm.byorReport.selectableDepts = [];
        oldSelectableDepts.forEach(d => {
            const selected = (reportSpec.merchantLocs.some(ml => ml.id === d.id));
            vm.byorReport.selectableDepts.push(new SelectableDept(d.id, d.name, selected));
        });
        vm.byorReport.selectableDeptsRows = splitIntoRows(vm.byorReport.selectableDepts);
    }

    vm.addReportEmail = function() {
        $log.info('addTransactionReportEmail called');
        if (vm.form.errors && vm.form.errors.email) {
            vm.form.errors.email = '';
        }
        vm.byorReport.emailList.push(vm.email);
        vm.email = null;
    };

    vm.removeTransactionReportEmail = function(index) {
        vm.byorReport.emailList.splice(index, 1);
    };

    vm.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    vm.addColumn = function() {
        const columnsToAdd = [];
        const modalInstance = $uibModal.open({
            template: require('./byorColumnSelect.html'),
            controller: 'ByorSelectColumnController',
            controllerAs: 'vm',
            windowClass: 'fade modal-huge',
            backdrop: 'static',
            resolve: {
                availableColumns() {
                    return vm.allAvailableByorColumns.filter(f1 =>
                        !vm.byorReport.selectedColumns.some(f2 => f1.name === f2.name)
                    );
                },
                columnsToAdd() {
                    return columnsToAdd;
                }
            }
        });
        modalInstance.result
            .then(() => columnsToAdd.forEach(col => {
                vm.byorReport.selectedColumns.push(new ByorColumn(col.name, col.label));
            }))
            .catch(reason => messageService.error('initialisation error', reason));
    };

    vm.removeCol = function(name) {
        $log.log('removeCol: ' + name);
        vm.byorReport.selectedColumns = vm.byorReport.selectedColumns.filter(f => f.name !== name);
    };

    vm.save = function() {
        messageService.hide();
        if (!validate()) {
            return;
        }
        vm.busy = true;

        if (vm.byorReport.scheduleInterval === 'daily') {
            vm.byorReport.scheduleDay = utils.getSelectedDaysList(vm.days);
        }

        byorService.createByorReport(vm.byorReport, !vm.generating)
            .then((resp) => {
                if (!vm.generating) {
                    if($routeParams && $routeParams.outletId) {
                        $location.path('/merchant/outlet/' + $routeParams.outletId + '/reports');
                    }
                    else {
                        $location.path('/report');
                    }
                } else {
                    poll(resp.id, 'excel', 'transaction');
                }
            })
            .catch(err => {
                vm.busy = false;
                vm.form.errors = reportsErrorService
                    .handleServerError(err.data.errors);
            });
    };

    function validate() {
        const errors = [];
        vm.form.errors = {};
        if (!vm.generating && !vm.byorReport.name) {
            vm.form.errors.name = gettextCatalog.getString('Name is required');
            errors.push('name');
        }
        if (!vm.generating && vm.byorReport.emailList.length === 0) {
            vm.form.errors.email = gettextCatalog.getString('Need to add at least one email address');
            errors.push('email');
        }
        if (errors.length) {
            $log.info('Failed validation', errors);
        }
        return errors.length === 0;
    }

    vm.cancel = function() {
        if($routeParams && $routeParams.outletId) {
            $location.path('/merchant/outlet/' + $routeParams.outletId + '/reports');
        }
        else {
            $location.path('/report');
        }
    };

    function poll(id, format, reportType) {
        vm.timeoutPoll = $timeout(() => {
            // Poll for report
            reportService.pollReport(id)
                .then((pollResponseData) => {
                    $log.info('poll responded');
                    // Check if error on the report
                    if (pollResponseData.error) {
                        vm.busy = false;
                        $log.info('Got error', pollResponseData.error);
                        messageService.error('save error', pollResponseData.error);
                    } else if (pollResponseData.reportType === 'no-data') {
                        vm.busy = false;
                        messageService.warning('No data in this reporting period');
                    } else if (pollResponseData.percentComplete === 100) {
                        vm.busy = false;
                        $log.info('Complete', id, format);
                        $window.location = appConfig.apiUrl + 'reportControl/' + pollResponseData.id + '/' + format;
                    } else {
                        $log.info('poll again');
                        poll(id, format, reportType);
                    }
                })
                .catch(error => messageService.error('save error', error));
        }, 2500);

        $scope.$on('$destroy', (event) => $timeout.cancel(vm.timeoutPoll));
    }

    init();
}




// WEBPACK FOOTER //
// ./src/reports/outlet/byor/byor.controller.js